import React, { ComponentType } from 'react';

import { withHeaderState } from '@bingads-webui-campaign-react/overview-card';


import { AssetPerformanceCardProps } from '../utils/types';
import { useFilteredAssetData } from './use-filtered-asset-data';
import { State } from '../filter/types';

type ChildProps = AssetPerformanceCardProps & { headerState?: State, dateRange: { start: Date, end: Date } };
export function withFilteredAssetData<P extends AssetPerformanceCardProps>(WrappedComponent: ComponentType<P>): ComponentType<Omit<P, 'assets'>> {
  const HoC = (props: ChildProps) => {
    const { headerState, dateRange } = props;
    const { assets, isLoading } = useFilteredAssetData(headerState, dateRange);
    return (<WrappedComponent
      {...props as any}
      assets={assets}
      isLoading={isLoading}
    />);
  };
  HoC.defaultProps = {
    headerState: undefined,
  };
  return withHeaderState(HoC);
}
